import unauthenticatedHttp from "@/services/unauthenticatedHttp";
import { freeContentResponse } from "@/services/unauthService/types";

export async function freeContents() {
  const { data } = await unauthenticatedHttp().get(`${globalThis.env.API_UNAUTH}/freeContent`);

  return freeContentResponse.parse(data);
}
